import { ExpressionRuleEditor } from "../ExpressionRuleEditor";
import { BracketedDiv, ExpressionPiece } from "../../Builder/ExpressionStyles";
import { ExpressionValueRenderer } from "../../Builder/ExpressionValueRenderer";
import React from "react";
import { StringLowercaseExpression } from "../../../rule-engine-core/Expressions/Expressions/String/StringLowercaseExpression";

export class StringLowercaseExpressionEditor extends ExpressionRuleEditor<StringLowercaseExpression> {
    render() {
        return (
            <>
                <ExpressionPiece>
                    <BracketedDiv>
                        <ExpressionValueRenderer el={this.ruleData!.value1!} />
                    </BracketedDiv>
                    <ExpressionPiece>to lower case</ExpressionPiece>
                </ExpressionPiece>
            </>
        );
    }
}
